export const SocialMedia = [
    {
        name: "Facebook",
        icon: "icon-facebook1",
        link: `https://www.facebook.com/sharer/sharer.php?u=`,
    },
    {
        name: "Whatsapp",
        icon: "icon-whatsapp",
        link: `https://api.whatsapp.com/send?text=`,
    },
    {
        name: "Linkedin",
        icon: "icon-linkedin1",
        link: `https://www.linkedin.com/shareArticle?mini=true&url=`,
    },
]